<div mat-dialog-title id="unsubscribe">Unsubscribe
  <div class="dialog-close-button">
    <a (click)="onClose()" id="close">
      <img src="/assets/images/close-popup.png">
    </a>
  </div>
</div>
<form>
  <div mat-dialog-content cdkFocusInitial>
    <p class="cartText" name="date" id="unsubscribe-msg">By clicking YES you are confirming you would like to unsubscribe from future
      shipments of these items.</p>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close]="true" id="btn-yes" class="yes">YES</button>
    <button mat-raised-button [mat-dialog-close]="false" id="btn-no" class="no">NO</button>
  </div>
</form>